export default __webpack_public_path__ + "static/media/questions-md-2x.6950e21e.webp";